import React from 'react';
import GeneralStyle from './GeneralStyles';


const Style = function Style() {
  return (
    <>
      <GeneralStyle />
    </>
  );
};

export default Style;